"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2853],{

/***/ 2168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ settings; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/layout/LayoutAdapter.tsx
var LayoutAdapter = __webpack_require__(39891);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/api/Purchases.ts
var Purchases = __webpack_require__(4216);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./src/hooks/auth/index.ts + 10 modules
var auth = __webpack_require__(12849);
// EXTERNAL MODULE: ./src/hooks/purchases/useCurrentSubscription.ts
var useCurrentSubscription = __webpack_require__(12678);
// EXTERNAL MODULE: ./src/hooks/useRouter.ts
var useRouter = __webpack_require__(98377);
// EXTERNAL MODULE: ./src/providers/hooks/usePaywall.ts + 1 modules
var usePaywall = __webpack_require__(10098);
// EXTERNAL MODULE: ./src/providers/hooks/useAuth.ts + 1 modules
var useAuth = __webpack_require__(79139);
// EXTERNAL MODULE: ./src/providers/hooks/useProfile.ts
var useProfile = __webpack_require__(2334);
// EXTERNAL MODULE: ./src/theme/typography.ts
var typography = __webpack_require__(43795);
// EXTERNAL MODULE: ./src/types/enums.ts
var enums = __webpack_require__(41390);
// EXTERNAL MODULE: ./src/utils/strings/pageStrings.ts
var pageStrings = __webpack_require__(23244);
// EXTERNAL MODULE: ./src/components/cards/BaseCard.tsx
var BaseCard = __webpack_require__(46039);
;// CONCATENATED MODULE: ./src/page-components/settings/settings-page/SettingsCard.tsx






var SettingsCard = function(param) {
    var title = param.title, description = param.description, selectTab = param.selectTab, value = param.value;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var renderIcon = function() {
        var boxSize = esm.spacing.toRem(40);
        switch(value){
            case SettingsType.Emails:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.MailSvg, {
                    color: esm.color[colorMode].text,
                    boxSize: boxSize
                });
            case SettingsType.PersonalInformation:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PersonSvg, {
                    color: esm.color[colorMode].text,
                    boxSize: boxSize
                });
            case SettingsType.Preferences:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.SettingsSvg, {
                    color: esm.color[colorMode].text,
                    boxSize: boxSize
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {});
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseCard/* default */.Z, {
        flexDirection: "column",
        onClick: function() {
            return selectTab();
        },
        p: esm.spacing.toRem(32),
        pt: esm.spacing.toRem(36),
        _hover: {
            cursor: "pointer"
        },
        hasHoverEffect: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                children: renderIcon()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                alignContent: "center",
                pt: esm.spacing.toRem(8),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryHeading, {
                    size: "h1",
                    type: "bold",
                    color: esm.color[colorMode].text,
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                color: esm.color[colorMode].textSecondary,
                children: description
            })
        ]
    });
};
/* harmony default export */ var settings_page_SettingsCard = (SettingsCard);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/api/Profile.ts
var Profile = __webpack_require__(75897);
;// CONCATENATED MODULE: ./src/theme/icons/ExportSvg.tsx





var ExportSvg = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Icon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.82356 11.9983H4.53255C7.5 11.9982 7 12 6.17927 11.9983L11.1249 11.9978L11.1238 10.9961L11.1194 10.9951V9.49388L11.1238 9.49488L11.1238 4.55505L9.23147 6.27776C8.93911 6.54403 8.48168 6.56816 8.1594 6.35022L8.06706 6.27758C7.7748 6.01122 7.74831 5.59448 7.98753 5.30086L8.06726 5.21674L11.3581 2.21962C11.6502 1.9536 12.1071 1.92922 12.4294 2.14663L12.5218 2.2191L15.819 5.21622C16.1409 5.50883 16.1415 5.98379 15.8203 6.27706C15.5283 6.54368 15.0709 6.56836 14.7483 6.35081L14.6559 6.27827L12.7705 4.56505L12.7716 11.9978L17.7074 11.9983C17.7074 11.9983 15.5 11.9983 19.3541 11.9983H20.1764C20.6884 11.9983 21.0763 12.4195 20.9872 12.8789L19.3391 21.3803C19.2696 21.7387 18.9278 22 18.5283 22H5.35592C4.95269 22 4.60879 21.7339 4.54345 21.3714L3.01108 12.87C2.92876 12.4133 3.31557 11.9983 3.82356 11.9983ZM4.79316 13.4986L6.0551 20.4997H17.8376L19.1949 13.4986L4.79316 13.4986Z",
            fill: "#3B3F44"
        })
    }));
};

// EXTERNAL MODULE: ./src/utils/constants.tsx
var constants = __webpack_require__(14531);
;// CONCATENATED MODULE: ./src/components/buttons/ExportLibraryButton.tsx













var ExportLibraryButton = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var colorMode = (0,esm.useColorMode)().colorMode;
    var profile = (0,useProfile/* default */.Z)().profile;
    var toast = (0,esm.useToast)();
    var onClickHandler = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            (0,Profile/* postExportLibrary */.Kw)().then(function() {
                toast({
                    title: "Export initiated!",
                    description: "Please check your email soon.",
                    status: "success",
                    duration: constants/* TOAST_TIME */.du,
                    isClosable: true
                });
                return;
            }).catch(function() {
                toast({
                    title: "Export in progress!",
                    description: "Another export has been already initiated. Wait for it to finish before starting a new one.",
                    status: "warning",
                    duration: constants/* TOAST_TIME */.du,
                    isClosable: true
                });
                return;
            });
            return [
                2
            ];
        });
    }), [
        profile === null || profile === void 0 ? void 0 : profile.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseCard/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        flexDirection: "column",
        p: esm.spacing.toRem(32),
        pt: esm.spacing.toRem(36),
        _hover: {
            cursor: "pointer"
        },
        onClick: onClickHandler,
        hasHoverEffect: true
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExportSvg, {
                    color: esm.color[colorMode].text,
                    boxSize: esm.spacing.toRem(40)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                alignContent: "center",
                pt: esm.spacing.toRem(8),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryHeading, {
                    size: "h1",
                    type: "bold",
                    color: esm.color[colorMode].text,
                    children: "Export Library"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                color: esm.color[colorMode].textSecondary,
                children: "Export your saved ideas via email."
            })
        ]
    }));
};
/* harmony default export */ var buttons_ExportLibraryButton = (ExportLibraryButton);

;// CONCATENATED MODULE: ./src/page-components/settings/settings-page/SettingsPage.tsx

















var SettingsType;
(function(SettingsType) {
    SettingsType["PersonalInformation"] = "personal-information";
    SettingsType["Preferences"] = "preferences";
    SettingsType["Emails"] = "email-subscriptions";
})(SettingsType || (SettingsType = {}));
var FAQ_URL = "https://www.notion.so/deepstash/Help-Center-e3fdf92e3ec64ebea90a1c0c56ebf3bc#fde9bb9c5bb44f97b6c85575405721d3";
var settingsList = [
    {
        title: "Personal Information",
        description: "Details about your name, profile & email.",
        value: SettingsType.PersonalInformation
    },
    {
        title: "Preferences",
        description: "Customize your experience with display options or a custom reading goal. ",
        value: SettingsType.Preferences
    },
    {
        title: "Emails",
        description: "Choose which emails you would like to receive.",
        value: SettingsType.Emails
    }, 
];
var SettingsPage = function() {
    (0,auth/* useHandleNsi */.Xc)({
        onNsiEnterAction: "redirect"
    });
    var colorMode = (0,esm.useColorMode)().colorMode;
    var router = (0,useRouter/* default */.Z)();
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var ref = (0,useCurrentSubscription/* default */.Z)(), currentSubscription = ref.currentSubscription, fetchCurrentSubscription = ref.fetchCurrentSubscription;
    var profile = (0,useProfile/* default */.Z)().profile;
    var ref1 = (0,react.useState)(), stripeCustomerPortal = ref1[0], setStripeCustomerPortal = ref1[1];
    (0,react.useEffect)(function() {
        // make sure if the user logs in, we update the subscription
        fetchCurrentSubscription();
    }, [
        isLoggedIn
    ]);
    var manageOnWeb = (currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.initialPaymentLocation) === "web";
    var openFAQPage = function() {
        window.open(FAQ_URL, "_blank");
    };
    var openStripePortal = function() {
        // make the api call only once
        if (stripeCustomerPortal === null || stripeCustomerPortal === void 0 ? void 0 : stripeCustomerPortal.link) {
            window.open(stripeCustomerPortal.link, "_blank");
            return;
        }
        // make sure we only make one api call when user is clicking rapidly
        if ((stripeCustomerPortal === null || stripeCustomerPortal === void 0 ? void 0 : stripeCustomerPortal.reqStatus) === "loading") {
            return;
        }
        setStripeCustomerPortal({
            reqStatus: "loading"
        });
        (0,Purchases/* getStripeManageSubscriptionLink */.Aq)().then(function(response) {
            setStripeCustomerPortal({
                reqStatus: "success",
                link: response.session_url
            });
            window.open(response.session_url, "_blank");
        }).catch(function() {
            setStripeCustomerPortal({
                reqStatus: "failure"
            });
        });
    };
    var renderManageSubscriptionButton = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(esm.Flex, {
            onClick: openStripePortal,
            paddingX: "0.8rem",
            paddingY: "0.7rem",
            width: "auto",
            cursor: "pointer",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.LockSvg, {
                    color: esm.color[colorMode].primary.default
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                    size: "m",
                    type: "bold",
                    marginX: "0.4rem",
                    children: "Manage subscription"
                }),
                (stripeCustomerPortal === null || stripeCustomerPortal === void 0 ? void 0 : stripeCustomerPortal.reqStatus) === "failure" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                    color: esm.color.failure["default"],
                    marginX: "0.3rem",
                    children: "Try again"
                }),
                (stripeCustomerPortal === null || stripeCustomerPortal === void 0 ? void 0 : stripeCustomerPortal.reqStatus) === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                    marginTop: "0.3rem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Spinner, {
                        width: 14,
                        height: 14
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.ExternalSvg, {
                    color: (stripeCustomerPortal === null || stripeCustomerPortal === void 0 ? void 0 : stripeCustomerPortal.reqStatus) === "failure" ? esm.color.failure["default"] : esm.color[colorMode].primary.default,
                    boxSize: 16
                })
            ]
        });
    };
    var renderManageOnDeviceButton = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            onClick: openFAQPage,
            paddingX: "0.4rem",
            paddingY: "0.7rem",
            width: "auto",
            cursor: "pointer",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PhoneSvg, {
                    color: esm.color[colorMode].text
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                    size: "s",
                    color: esm.color[colorMode].text,
                    children: pageStrings/* default.settings.manageOnDevice */.Z.settings.manageOnDevice
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                    color: esm.color[colorMode].primary.default,
                    marginX: "0.3rem",
                    children: "Learn how"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.ExternalSvg, {
                    boxSize: 16
                })
            ]
        });
    };
    var onPaywallModalOpen = (0,usePaywall/* default */.Z)().onPaywallModalOpen;
    var renderTryDeepstashPro = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            onClick: function() {
                onPaywallModalOpen({
                    location: enums/* PaywallAnalyticsLocation.SettingsPage */.P8.SettingsPage
                });
            },
            cursor: "pointer",
            width: "auto",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.LockSvg, {
                    color: esm.color[colorMode].pro.primary
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                    size: "m",
                    type: "bold",
                    color: esm.color[colorMode].pro.primary,
                    marginLeft: esm.spacing.XXS.rem,
                    children: pageStrings/* default.settings.tryDeepstashPRO */.Z.settings.tryDeepstashPRO
                })
            ]
        });
    };
    var renderSubscriptionButton = manageOnWeb ? renderManageSubscriptionButton : renderManageOnDeviceButton;
    var renderSubscriptionCTA = function() {
        if ((profile === null || profile === void 0 ? void 0 : profile.subscriptionType) === enums/* UserSubscriptionType.Premium */.A5.Premium && !currentSubscription) return null;
        return currentSubscription && (profile === null || profile === void 0 ? void 0 : profile.subscriptionType) === enums/* UserSubscriptionType.Premium */.A5.Premium ? renderSubscriptionButton() : renderTryDeepstashPro();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
        width: "100%",
        minH: "100vh",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                mb: "1rem",
                ml: {
                    base: "1rem",
                    lg: 0
                },
                flex: 1,
                justifyContent: "space-between",
                alignItems: "center",
                // When not rendering anything (i.e. while loading)
                // We need to minimize CLS, so we set the minH
                minH: esm.spacing.toRem(50),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, typography/* typography.heading.medium.primary.bold */.c.heading.medium.primary.bold), {
                        color: esm.color[colorMode].text,
                        children: pageStrings/* default.settings.title */.Z.settings.title
                    })),
                    renderSubscriptionCTA()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Grid, {
                gridTemplateColumns: {
                    base: "repeat(1, 1fr)",
                    lg: "repeat(3, 1fr)"
                },
                gridGap: "1rem",
                mx: {
                    base: "0.5rem",
                    lg: "unset"
                },
                children: [
                    settingsList.map(function(element) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(settings_page_SettingsCard, (0,_object_spread/* default */.Z)({
                            selectTab: function() {
                                router.push("/settings/".concat(element.value), undefined, {
                                    shallow: true
                                });
                            }
                        }, element), "settingsCard$".concat(element.title));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_ExportLibraryButton, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var settings_page_SettingsPage = (SettingsPage);

// EXTERNAL MODULE: ./src/utils/metadata.utils.ts
var metadata_utils = __webpack_require__(83337);
;// CONCATENATED MODULE: ./pages/settings/index.tsx






var index = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutAdapter/* default */.Z, {
        pageMetadata: (0,metadata_utils/* getSettingsPageMetadata */.Yz)(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(settings_page_SettingsPage, {})
    });
};
/* harmony default export */ var settings = (index);


/***/ }),

/***/ 54159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getRandomBookRatingById; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91260);
/* harmony import */ var src_components_layout_components_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56096);
/* harmony import */ var src_components_layout_components_FullWidthSectionWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41140);
/* harmony import */ var src_components_metadata_HeadMetadata__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37066);
/* harmony import */ var src_components_navbar_Navbar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43117);
/* harmony import */ var src_components_hashtag_HashtagChipCarousel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41914);
/* harmony import */ var src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50752);
/* harmony import */ var theme_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49834);
/* harmony import */ var utils_normalizers_source__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27079);
/* harmony import */ var src_components_source_source_collapsed_SourceCollapsed__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85611);
/* harmony import */ var _collection_old_CollectionSourceHighlightedIdeas__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(24311);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(30653);
/* harmony import */ var utils_html_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(77757);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(63069);





















var INTRODUCTORY_TITLE = "Your one stop book summary, audiobook and book review spot for:";
// Use in case topics are not found for the book
var HASHTAGS_FALLBACK = [
    "psychology",
    "motivationandinspiration",
    "personaldevelopment",
    "books",
    "leadershipandmanagement",
    "business",
    "philosophy", 
];
var getRandomBookRatingById = function(id) {
    var RATINGS = [
        "4.3",
        "4.4",
        "4.5",
        "4.6",
        "4.7",
        "4.8",
        "4.9"
    ];
    var modulo = id % RATINGS.length;
    return RATINGS[modulo];
};
var MasterBookPage = function(param) {
    var book = param.book, pageMetadata = param.pageMetadata;
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var isIos = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useDeviceDetect)().isIos;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(false), 2), descriptionExpanded = ref[0], setDescriptionExpanded = ref[1];
    var bookDescriptionString = react__WEBPACK_IMPORTED_MODULE_2__.useMemo(function() {
        return (0,react_html_parser__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(book.description, {
            transform: (0,utils_html_utils__WEBPACK_IMPORTED_MODULE_15__/* .makeTransformHtmlParserBookPageDescription */ .EC)()
        });
    }, [
        book
    ]);
    var bookRating = react__WEBPACK_IMPORTED_MODULE_2__.useMemo(function() {
        return getRandomBookRatingById(book.id);
    }, [
        book
    ]);
    var hashtags = react__WEBPACK_IMPORTED_MODULE_2__.useMemo(function() {
        if (!book.top_posts || book.top_posts.length === 0) {
            return [];
        }
        var allHashtags = [];
        if (book.top_posts && book.top_posts.length > 0) {
            book.top_posts.forEach(function(articleApiResponse) {
                // each article
                if (articleApiResponse.blocks && articleApiResponse.blocks.length > 0) {
                    var _allHashtags;
                    var ref;
                    var ref1;
                    var lowerCaseHashtags = (ref1 = (ref = articleApiResponse.blocks[0].hashtags) === null || ref === void 0 ? void 0 : ref.map(function(value) {
                        return value.toLowerCase();
                    })) !== null && ref1 !== void 0 ? ref1 : [];
                    (_allHashtags = allHashtags).push.apply(_allHashtags, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(lowerCaseHashtags !== null && lowerCaseHashtags !== void 0 ? lowerCaseHashtags : []));
                }
            });
        }
        if (allHashtags.length === 0) {
            return HASHTAGS_FALLBACK;
        }
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(new Set(allHashtags)).slice(0, 10);
    }, [
        book
    ]);
    var hashtagsChipData = react__WEBPACK_IMPORTED_MODULE_2__.useMemo(function() {
        return hashtags.map(function(item) {
            return {
                name: item
            };
        });
    }, [
        hashtags
    ]);
    var publishersNameJoin = react__WEBPACK_IMPORTED_MODULE_2__.useMemo(function() {
        if (book.publishers === undefined || book.publishers.length === 0) {
            return "";
        }
        var allNames = book.publishers.map(function(publisher) {
            return publisher.name;
        });
        return allNames.join(", ");
    }, [
        book
    ]);
    var renderAuthorsSection = function() {
        if (book.publishers === undefined || book.publishers.length === 0) {
            return null;
        }
        var publishersTotal = book.publishers.length;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
            flexDirection: "row",
            mt: "0.5rem",
            gridColumnGap: 8,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                    type: "regular",
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                    size: "l",
                    children: "by"
                }),
                book.publishers.map(function(publisher, index) {
                    var publisherSlug = (0,utils_global__WEBPACK_IMPORTED_MODULE_16__/* .slugify */ .lV)(publisher.name);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        href: "/book/author/".concat(publisher.id, "/").concat(publisherSlug),
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Link, {
                            _focus: undefined,
                            _hover: undefined,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                                type: "semiBold",
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                                size: "l",
                                children: [
                                    publisher.name,
                                    index < publishersTotal - 1 && ","
                                ]
                            })
                        })
                    }, "publisher-".concat(index));
                })
            ]
        });
    };
    var aboutThisBookSection = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
        flexDirection: "column",
        mt: "2rem",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                flexDirection: "row",
                justifyContent: "space-between",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                    type: "semiBold",
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                    size: "l",
                    children: "About ".concat(book.title, " Book")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                size: "m",
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                noOfLines: descriptionExpanded ? undefined : 3,
                children: bookDescriptionString
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                _hover: {
                    cursor: "pointer"
                },
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                onClick: function() {
                    setDescriptionExpanded(function(prevValue) {
                        return !prevValue;
                    });
                },
                children: descriptionExpanded ? "See Less" : "See More"
            })
        ]
    });
    var alsoGrabSection = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
        flexDirection: "column",
        mt: "2rem",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                type: "semiBold",
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                size: "l",
                children: "Also grab ".concat(book.title, " Audiobook, with the Deepstash App.")
            }),
            isMobileView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.AppStoreButton, {
                w: "100%",
                store: isIos ? "Apple" : "GooglePlay"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                flexDirection: "row",
                justifyContent: "flex-start",
                gridColumnGap: 16,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.AppStoreButton, {
                        w: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(192),
                        h: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(48),
                        store: "Apple"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.AppStoreButton, {
                        w: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(192),
                        h: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(48),
                        store: "GooglePlay"
                    })
                ]
            })
        ]
    });
    var dividerLine = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
        height: 2,
        bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].underground,
        width: "100%"
    });
    var topicsSection = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            dividerLine,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_hashtag_HashtagChipCarousel__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                hashtags: hashtagsChipData,
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                numberOfChipsThreshold: isMobileView ? 1 : 10,
                renderItem: function(item) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        href: "/topic/".concat(item.item.name),
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Link, {
                            _focus: undefined,
                            _hover: undefined,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                                size: "m",
                                mr: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XXS.rem,
                                children: [
                                    "#",
                                    item.item.name
                                ]
                            })
                        })
                    });
                }
            })
        ]
    });
    var statsSection = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            dividerLine,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        alignItems: "center",
                        gridRowGap: 8,
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(theme_icons__WEBPACK_IMPORTED_MODULE_10__/* .Star */ .Ux, {
                                width: 48,
                                height: 48
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                                textAlign: {
                                    base: "center",
                                    md: "unset"
                                }
                            }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.medium.regular), {
                                children: "".concat(bookRating, "/5 (").concat(book.identifier.slice(-4), " reviews)")
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        alignItems: "center",
                        gridRowGap: 8,
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.HeadphonesSvg, {
                                width: 48,
                                height: 48
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                                textAlign: {
                                    base: "center",
                                    md: "unset"
                                }
                            }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.medium.regular), {
                                children: "Audio and text"
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        alignItems: "center",
                        gridRowGap: 8,
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.DownloadSvg, {
                                width: 48,
                                height: 48
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                                textAlign: {
                                    base: "center",
                                    md: "unset"
                                }
                            }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.medium.regular), {
                                children: "Download free PDF"
                            }))
                        ]
                    })
                ]
            }),
            dividerLine
        ]
    });
    var renderSource = function(param) {
        var source = param.source;
        var highlightedIdeas = source.ideas.slice(0, 3);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_source_source_collapsed_SourceCollapsed__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    size: "large",
                    source: source,
                    headingSize: "h2"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_collection_old_CollectionSourceHighlightedIdeas__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    ideas: highlightedIdeas,
                    source: source
                })
            ]
        });
    };
    var imageComponent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        wrapperStyle: {
            width: 220,
            height: 320,
            cursor: "default"
        },
        imageUrl: book.image,
        alt: "".concat(book.title, " by ").concat(publishersNameJoin),
        blurhash: book.image_blurhash,
        priority: true
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_metadata_HeadMetadata__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                pageMetadata: pageMetadata
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_layout_components_FullWidthSectionWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_navbar_Navbar__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_layout_components_FullWidthSectionWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                my: utils_global__WEBPACK_IMPORTED_MODULE_16__/* .GAP_SIZE_REM */ .L3,
                containerProps: {
                    flexDirection: isMobileView ? "column-reverse" : "row"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        flexDirection: "column",
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                                type: "regular",
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                                size: "l",
                                children: INTRODUCTORY_TITLE
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryHeading, {
                                textSize: "l",
                                type: "bold",
                                size: "h1",
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                                mt: 16,
                                children: "".concat(book.title, " Summary")
                            }),
                            renderAuthorsSection(),
                            aboutThisBookSection,
                            alsoGrabSection
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        justifyContent: "center",
                        children: imageComponent
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_layout_components_FullWidthSectionWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                flexGrow: 1,
                containerProps: {
                    flexDirection: "column"
                },
                children: [
                    topicsSection,
                    statsSection
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_layout_components_FullWidthSectionWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                flexGrow: 1,
                containerProps: {
                    flexDirection: "column"
                },
                py: 32,
                children: book.top_posts && book.top_posts.length > 0 && book.top_posts.map(function(articleApi, _index) {
                    var normalizedSource = (0,utils_normalizers_source__WEBPACK_IMPORTED_MODULE_11__/* .normalizeSource */ .Nr)(articleApi);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: renderSource({
                            source: normalizedSource
                        })
                    });
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_layout_components_Footer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MasterBookPage);


/***/ }),

/***/ 24311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var pages_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2168);
/* harmony import */ var src_components_idea_card_IdeaCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63848);
/* harmony import */ var theme_size__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28953);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63069);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14531);
/* harmony import */ var utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89134);
/* harmony import */ var providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79139);
/* harmony import */ var providers_hooks_useNsi__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9182);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_11__);














var CollectionSourceHighlightedIdeas = function(param) {
    var ideas = param.ideas, source = param.source;
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var nsiDispatch = (0,providers_hooks_useNsi__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)().nsiDispatch;
    var isLoggedIn = (0,providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)().isLoggedIn;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_11__.useRouter)();
    var onClickCtaHandler = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function() {
        if (!isLoggedIn) {
            nsiDispatch({
                type: "openAuth",
                payload: {
                    type: "sign-up"
                }
            });
        } else {
            router.push("/article/".concat(source.id, "/").concat((0,utils_global__WEBPACK_IMPORTED_MODULE_5__/* .slugify */ .lV)(source.title)));
        }
    }, [
        isLoggedIn,
        source.id
    ]);
    if (!ideas || ideas.length === 0) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        w: {
            base: "auto",
            md: (0,utils_global__WEBPACK_IMPORTED_MODULE_5__/* .getRemWidthFromColumns */ ._P)(8),
            lg: (0,utils_global__WEBPACK_IMPORTED_MODULE_5__/* .getRemWidthFromColumns */ ._P)(12)
        }
    }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.large.regular), {
        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
        mt: utils_global__WEBPACK_IMPORTED_MODULE_5__/* .GAP_SIZE_REM */ .L3,
        gridGap: utils_global__WEBPACK_IMPORTED_MODULE_5__/* .GAP_SIZE_REM */ .L3,
        padding: {
            base: 0,
            md: utils_global__WEBPACK_IMPORTED_MODULE_5__/* .GAP_SIZE_REM */ .L3
        },
        height: "auto",
        maxHeight: {
            base: "auto",
            md: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(400)
        },
        position: "relative",
        overflow: "hidden",
        flexDirection: {
            base: "column",
            md: "row"
        },
        backgroundColor: {
            base: "transparent",
            md: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface
        },
        alignItems: "flex-start",
        borderRadius: theme_size__WEBPACK_IMPORTED_MODULE_4__/* .BORDER_RADIUS_M */ .$W,
        children: [
            ideas.map(function(idea, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_idea_card_IdeaCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    ideaData: {
                        idea: idea,
                        source: source
                    }
                }, index);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                position: "absolute",
                width: "100%",
                height: "66%",
                background: (0,utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .createGradient */ .FK)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface, 270),
                zIndex: 1,
                bottom: 0,
                left: 0,
                alignItems: "flex-end",
                padding: utils_global__WEBPACK_IMPORTED_MODULE_5__/* .GAP_SIZE_REM */ .L3,
                justifyContent: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                    size: "lg",
                    onClick: onClickCtaHandler,
                    _hover: {
                        backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode === "dark" ? "light" : "dark"].underground
                    },
                    width: {
                        base: "100%",
                        md: (0,utils_global__WEBPACK_IMPORTED_MODULE_5__/* .getRemWidthFromColumns */ ._P)(3)
                    },
                    height: "auto",
                    transition: "background-color 0.3s ease-out",
                    backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textInverted
                }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.large.semiBold), {
                    align: "center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, {
                        children: isLoggedIn ? utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_8__/* ["default"].readIdeas */ .Z.readIdeas : utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_8__/* ["default"].signUpToReadForFree */ .Z.signUpToReadForFree
                    })
                }))
            })
        ]
    }), "answer-".concat(pages_settings__WEBPACK_IMPORTED_MODULE_2__["default"]));
};
/* harmony default export */ __webpack_exports__["Z"] = (CollectionSourceHighlightedIdeas);


/***/ }),

/***/ 83337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ getTopicPageMetadata; },
/* harmony export */   "$J": function() { return /* binding */ getRedeemPageMetadata; },
/* harmony export */   "$j": function() { return /* binding */ getPasswordResetPageMetadata; },
/* harmony export */   "$t": function() { return /* binding */ getIdeaPageMetadata; },
/* harmony export */   "AZ": function() { return /* binding */ getDraftPageMetadata; },
/* harmony export */   "Ar": function() { return /* binding */ getStashesPageMetadata; },
/* harmony export */   "BD": function() { return /* binding */ getContentReviewArticlesAllDraftsPageMetadata; },
/* harmony export */   "Be": function() { return /* binding */ getNotificationsPageMetadata; },
/* harmony export */   "Bh": function() { return /* binding */ getTermsOfServicePageMetadata; },
/* harmony export */   "C7": function() { return /* binding */ getForTeamsPageMetadata; },
/* harmony export */   "DD": function() { return /* binding */ getContentReviewArticlePageMetadata; },
/* harmony export */   "DW": function() { return /* binding */ getInfluencerPageMetadata; },
/* harmony export */   "Hw": function() { return /* binding */ getExploreDailyPicksHistoryMetadata; },
/* harmony export */   "JH": function() { return /* binding */ getStudioPageMetadata; },
/* harmony export */   "Jp": function() { return /* binding */ getBookAuthorPageMetadata; },
/* harmony export */   "K7": function() { return /* binding */ getCuratorsPageMetadata; },
/* harmony export */   "Lj": function() { return /* binding */ getExplorePageMetadata; },
/* harmony export */   "NJ": function() { return /* binding */ getCollectionPageMetadata; },
/* harmony export */   "Nj": function() { return /* binding */ getRefPageMetadata; },
/* harmony export */   "PZ": function() { return /* binding */ getMobileAppPageMetadata; },
/* harmony export */   "Q8": function() { return /* binding */ getPersonalInformationPageMetadata; },
/* harmony export */   "T2": function() { return /* binding */ getExploreSourceTypeSeeAllPageMetadata; },
/* harmony export */   "TV": function() { return /* binding */ getProfilePageMetadata; },
/* harmony export */   "VL": function() { return /* binding */ getRecommendedPageMetadata; },
/* harmony export */   "Yz": function() { return /* binding */ getSettingsPageMetadata; },
/* harmony export */   "_1": function() { return /* binding */ getStashingPageMetadata; },
/* harmony export */   "aH": function() { return /* binding */ getBookPageMetadata; },
/* harmony export */   "b6": function() { return /* binding */ getSearchPageMetadata; },
/* harmony export */   "bN": function() { return /* binding */ getPressKitPageMetadata; },
/* harmony export */   "dC": function() { return /* binding */ getEmailUnsubscribePageMetadata; },
/* harmony export */   "gU": function() { return /* binding */ getErrorPageMetadata; },
/* harmony export */   "gn": function() { return /* binding */ getFollowingPageMetadata; },
/* harmony export */   "hj": function() { return /* binding */ getContentReviewArticlesInReviewPageMetadata; },
/* harmony export */   "iL": function() { return /* binding */ getDeleteAccountPageMetadata; },
/* harmony export */   "ku": function() { return /* binding */ getExploreDailyPicksMetadata; },
/* harmony export */   "lC": function() { return /* binding */ getHomePageMetadata; },
/* harmony export */   "lh": function() { return /* binding */ getProductHuntPageMetadata; },
/* harmony export */   "mn": function() { return /* binding */ getPreferencesPageMetadata; },
/* harmony export */   "nS": function() { return /* binding */ getAboutPageMetadata; },
/* harmony export */   "qr": function() { return /* binding */ getExploreSourceTypePageMetadata; },
/* harmony export */   "rC": function() { return /* binding */ getStoryPageMetadata; },
/* harmony export */   "t7": function() { return /* binding */ getArticlePageMetadata; },
/* harmony export */   "u9": function() { return /* binding */ getAllCollectionsPageMetadata; },
/* harmony export */   "uo": function() { return /* binding */ getEmailSubscriptionsPageMetadata; },
/* harmony export */   "vB": function() { return /* binding */ getPrivacyPolicyMetadata; },
/* harmony export */   "wm": function() { return /* binding */ getGetProPageMetadata; },
/* harmony export */   "yH": function() { return /* binding */ getProgressPageMetadata; },
/* harmony export */   "zy": function() { return /* binding */ getStashPageMetadata; }
/* harmony export */ });
/* unused harmony exports getFeaturedPageMetadata, getTrendingPageMetadata, getLikesPageMetadata */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var pages_search__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35905);
/* harmony import */ var react_schemaorg_dist_src_json_ld__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82342);
/* harmony import */ var src_page_components_books_MasterBookPage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54159);
/* harmony import */ var types_enums__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41390);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63069);
/* harmony import */ var _strings_commonStrings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51599);
/* harmony import */ var _strings_pageStrings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23244);









var DEFAULT_PUBLIC_PAGE_OG_TAGS = {
    title: "Deepstash - Replace doomscrolling with microlearning!",
    type: "website",
    image: "https://static.deepstash.com/deepstash_web_share_cover.jpg",
    description: "Stop doomscrolling. Start microlearning. Join 3M+ smart people like you."
};
/**
 * @link /[hashTag]
 * @returns {PageMetadata} opengraph metadata
 */ var getTopicPageMetadata = function(param) {
    var topicName = param.topicName, topicTitle = param.topicTitle, exampleArticleTitle = param.exampleArticleTitle, pageCount = param.pageCount, pageTitleFromProps = param.pageTitle, pageDescriptionFromProps = param.pageDescription;
    // Discover amazing ideas on #{topic name} like {article name} or many others.
    var pageDescription = pageDescriptionFromProps !== null && pageDescriptionFromProps !== void 0 ? pageDescriptionFromProps : "Discover amazing ideas on ".concat(topicTitle) + (!!exampleArticleTitle && exampleArticleTitle !== "" ? " like ".concat(exampleArticleTitle, " or many others.") : ".");
    var topicPageMetadata = {
        pageTitle: pageTitleFromProps !== null && pageTitleFromProps !== void 0 ? pageTitleFromProps : topicTitle + " - Deepstash",
        pageDescription: pageDescription,
        canonical: "https://deepstash.com/topic/".concat(topicName).concat(pageCount ? "/".concat(pageCount) : ""),
        robotsTag: "index",
        openGraphTags: {
            type: "topic",
            description: "Get the best ideas on ".concat(topicTitle),
            title: topicTitle
        },
        twitterTags: {
            card: "summary_large_image"
        }
    };
    return topicPageMetadata;
};
/**
 * @link /book/[id]/[slug], 301 redirects: /book/[id], /book/[id]/[wrong-slug]
 * @returns {PageMetadata} jsonld + opengraph metadata
 */ var getBookPageMetadata = function(param) {
    var book = param.book;
    var ref;
    var authorNameJoin = book.publishers.map(function(publisher) {
        return publisher.name;
    }).join(", ");
    var bookPageDescription = "Read the book summary of ".concat(book.title, " by ").concat(authorNameJoin, " in 5m or less. Browse hundreds of key ideas from several different book summaries by Deepstash users.");
    var canonicalUrl = "https://deepstash.com/book/".concat(book.id, "/").concat((0,_global__WEBPACK_IMPORTED_MODULE_4__/* .slugify */ .lV)(book.title));
    var ratingCount = book.identifier.slice(-4);
    var randomBookRating = Number((0,src_page_components_books_MasterBookPage__WEBPACK_IMPORTED_MODULE_2__/* .getRandomBookRatingById */ .$)(book.id));
    var _image, ref1;
    var bookPageMetadata = {
        pageTitle: book.title + " Summary 2024",
        pageDescription: bookPageDescription,
        canonical: canonicalUrl,
        robotsTag: "index",
        openGraphTags: {
            title: book.title,
            description: bookPageDescription,
            type: "book",
            image: (_image = book.image) !== null && _image !== void 0 ? _image : undefined
        },
        twitterTags: {
            card: "summary_large_image"
        },
        authorTag: (ref1 = (ref = book.publishers) === null || ref === void 0 ? void 0 : ref.join(", ")) !== null && ref1 !== void 0 ? ref1 : undefined,
        structuredDataObjects: [
            (0,react_schemaorg_dist_src_json_ld__WEBPACK_IMPORTED_MODULE_1__.jsonLdScriptProps)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                "@context": "https://schema.org",
                "@type": "Book",
                "@id": canonicalUrl,
                mainEntityOfPage: {
                    "@type": "Book",
                    "@id": canonicalUrl
                }
            }, book.image && {
                image: book.image
            }), {
                dateModified: book.created_at,
                name: book.title,
                sameAs: canonicalUrl,
                author: {
                    "@type": "Person",
                    name: authorNameJoin
                },
                aggregateRating: {
                    "@type": "AggregateRating",
                    ratingValue: randomBookRating,
                    bestRating: 5,
                    ratingCount: Number.parseInt(ratingCount)
                }
            })), 
        ]
    };
    return bookPageMetadata;
};
/**
 * @link /book/author/[id]/[slug], 301 redirects: /book/author/[id], /book/author/[id]/[wrong-slug]
 * @returns {PageMetadata} jsonld + opengraph metadata
 */ var getBookAuthorPageMetadata = function(param) {
    var publisher = param.publisher;
    var ref;
    var publisherDescription = publisher.top_sources !== undefined && publisher.top_sources[0] !== undefined ? "Discover all ".concat(publisher.name, " books and read top summaries & key ideas from ").concat((ref = publisher.top_sources[0]) === null || ref === void 0 ? void 0 : ref.title, " and more.") : "Discover all ".concat(publisher.name, " books and read top summaries & key ideas.");
    var canonicalUrl = "https://deepstash.com/book/author/".concat(publisher.id, "/").concat((0,_global__WEBPACK_IMPORTED_MODULE_4__/* .slugify */ .lV)(publisher.name));
    var _image;
    var bookAuthorPageMetadata = {
        pageTitle: "".concat(publisher.name, ": Books & Author Bio 2024"),
        pageDescription: publisherDescription,
        canonical: canonicalUrl,
        robotsTag: "index",
        openGraphTags: {
            title: publisher.name,
            description: publisherDescription,
            type: "person",
            image: (_image = publisher.image) !== null && _image !== void 0 ? _image : undefined
        },
        twitterTags: {
            card: "summary_large_image"
        },
        authorTag: publisher.name,
        structuredDataObjects: [
            (0,react_schemaorg_dist_src_json_ld__WEBPACK_IMPORTED_MODULE_1__.jsonLdScriptProps)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                "@context": "https://schema.org",
                "@type": "Person",
                "@id": canonicalUrl
            }, publisher.image && {
                image: publisher.image
            }), {
                name: publisher.name,
                sameAs: canonicalUrl
            })), 
        ]
    };
    return bookAuthorPageMetadata;
};
/**
 * @link /article/[id]/[slug], 301 redirects: /article/[id], /article/[id]/[wrong-slug]
 * @returns {PageMetadata} jsonld + opengraph metadata
 */ var getArticlePageMetadata = function(param) {
    var article = param.article;
    var author = article.author, id = article.id, title = article.title, blocks = article.blocks, source_type = article.source_type, topics = article.topics, image_preview = article.image_preview;
    var articlePageDescriptionTopicsPrefix = topics ? " on " : "";
    topics === null || topics === void 0 ? void 0 : topics.slice(topics.length - 1).forEach(function(topic, index) {
        articlePageDescriptionTopicsPrefix += "#".concat(topic.name);
        if (index < topics.length - 1) {
            articlePageDescriptionTopicsPrefix += ", ";
        } else {
            articlePageDescriptionTopicsPrefix += " and ";
        }
    });
    articlePageDescriptionTopicsPrefix += topics ? topics[topics.length - 1].name : "";
    var articlePageDescription = "Learn something new today. " + "Discover ".concat(blocks ? blocks.length + " " : "") + "idea".concat(blocks && blocks.length === 1 ? "" : "s", " ") + "from this ".concat((0,_global__WEBPACK_IMPORTED_MODULE_4__/* .getSourceTypeTitle */ .qY)(source_type)) + articlePageDescriptionTopicsPrefix;
    var canonicalUrl = "https://deepstash.com/article/".concat(id, "/").concat((0,_global__WEBPACK_IMPORTED_MODULE_4__/* .slugify */ .lV)(title));
    var _title;
    var articlePageMetadata = {
        pageTitle: (_title = article.title) !== null && _title !== void 0 ? _title : "",
        pageDescription: articlePageDescription,
        canonical: canonicalUrl,
        robotsTag: "index",
        openGraphTags: {
            title: title,
            description: articlePageDescription,
            type: source_type === types_enums__WEBPACK_IMPORTED_MODULE_3__/* .SourceType.BOOK */ .PO.BOOK ? "book" : "article",
            image: image_preview !== null && image_preview !== void 0 ? image_preview : undefined
        },
        twitterTags: {
            card: "summary_large_image"
        },
        authorTag: author,
        structuredDataObjects: [
            (0,react_schemaorg_dist_src_json_ld__WEBPACK_IMPORTED_MODULE_1__.jsonLdScriptProps)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                "@context": "https://schema.org",
                "@type": source_type === types_enums__WEBPACK_IMPORTED_MODULE_3__/* .SourceType.BOOK */ .PO.BOOK ? "Book" : "Article",
                mainEntityOfPage: {
                    "@type": "WebPage",
                    "@id": canonicalUrl
                }
            }, article.image_compressed && {
                image: article.image_compressed
            }, article.image && {
                image: article.image
            }, article.image_preview && {
                image: article.image_preview
            }), {
                dateModified: article.updated_at,
                name: article.title,
                sameAs: canonicalUrl,
                author: {
                    "@type": "Person",
                    name: article.user_data.first_name + " " + article.user_data.last_name,
                    url: "https://deepstash.com/u/".concat(article.user_data.username)
                },
                isAccessibleForFree: true,
                hasPart: {
                    "@type": "WebPageElement",
                    isAccessibleForFree: false,
                    cssSelector: ".paywall"
                }
            })), 
        ]
    };
    return articlePageMetadata;
};
/**
 * @link /u/[username]
 * @returns {PageMetadata} jsonld + opengraph
 */ var getProfilePageMetadata = function(param) {
    var user = param.user;
    var name = user.first_name || user.last_name ? "".concat(user.first_name, " ").concat(user.last_name) : user.username;
    var _bio, _image_preview, _bio1, _image_preview1, _bio2;
    var usernamePageMetadata = {
        pageTitle: "".concat(name, " (@").concat(user.username, ")"),
        pageDescription: "Find the latest ideas from ".concat(name, " (@").concat(user.username, "). ").concat((_bio = user.bio) !== null && _bio !== void 0 ? _bio : ""),
        canonical: "https://deepstash.com/u/".concat(user.username),
        robotsTag: user.num_published_articles >= 2 ? "index" : "noindex, nofollow",
        openGraphTags: {
            title: user.username,
            image: (_image_preview = user.image_preview) !== null && _image_preview !== void 0 ? _image_preview : user.photo,
            description: "Find the latest ideas from ".concat(name, " (@").concat(user.username, "). ").concat((_bio1 = user.bio) !== null && _bio1 !== void 0 ? _bio1 : ""),
            type: "profile"
        },
        twitterTags: {
            card: "summary_large_image"
        },
        structuredDataObjects: [
            (0,react_schemaorg_dist_src_json_ld__WEBPACK_IMPORTED_MODULE_1__.jsonLdScriptProps)({
                "@context": "https://schema.org",
                "@type": "ProfilePage",
                mainEntity: {
                    "@type": "Person",
                    image: (_image_preview1 = user.image_preview) !== null && _image_preview1 !== void 0 ? _image_preview1 : user.photo,
                    name: name,
                    sameAs: user.twitter_username ? [
                        "https://deepstash.com/u/".concat(user.username),
                        "https://twitter.com/".concat(user.twitter_username), 
                    ] : "https://deepstash.com/u/".concat(user.username)
                },
                mainEntityOfPage: "https://deepstash.com/u/".concat(user.username),
                description: (_bio2 = user.bio) !== null && _bio2 !== void 0 ? _bio2 : ""
            }), 
        ]
    };
    return usernamePageMetadata;
};
/**
 * @link /stash/[id]/[slug], 301 redirects: /stash/[id], /stash/[id]/[wrong-slug]
 * @param {StashApiResponse} stash
 * @returns {PageMetadata} opengraph metadata
 */ var getStashPageMetadata = function(param) {
    var stash = param.stash;
    var ref;
    var _image_preview;
    var stashPageMetadata = {
        pageTitle: stash.name,
        pageDescription: "Get ".concat(stash.insights_count, " amazing ideas on ").concat(stash.name, "."),
        canonical: "https://deepstash.com/stash/".concat(stash.id, "/").concat((0,_global__WEBPACK_IMPORTED_MODULE_4__/* .slugify */ .lV)(stash.name)),
        robotsTag: "noindex",
        openGraphTags: {
            type: "stash",
            title: stash.name,
            image: (_image_preview = stash.image_preview) !== null && _image_preview !== void 0 ? _image_preview : stash.image,
            description: "Get ".concat(stash.insights_count, " amazing ideas on ").concat(stash.name, ".")
        },
        twitterTags: {
            card: "summary_large_image"
        },
        authorTag: (ref = stash.user_data) === null || ref === void 0 ? void 0 : ref.username
    };
    return stashPageMetadata;
};
/**
 * @link /idea/[id]/[slug], 301 redirects: /idea/[id], /idea/[id]/[wrong-slug]
 * @returns {PageMetadata} opengraph metadata
 */ var getIdeaPageMetadata = function(param) {
    var insight = param.insight;
    var insightPageTitle = insight.author_name ? "Quote by ".concat(insight.author_name) : "".concat((0,_global__WEBPACK_IMPORTED_MODULE_4__/* .cleanInsightTitle */ .CH)(insight));
    var insightPageDescription = insight.content.replace(/<\/?\s*[a-z]+[^>]*>/gi, "").split(" ").splice(0, 30).join(" ").concat("...");
    var _author_name;
    var ideaPageMetadata = {
        pageTitle: insightPageTitle,
        pageDescription: insightPageDescription,
        canonical: "https://deepstash.com/idea/".concat(insight.id, "/").concat((0,_global__WEBPACK_IMPORTED_MODULE_4__/* .slugify */ .lV)(insight.title, insight.content)),
        robotsTag: "index",
        openGraphTags: {
            type: "idea",
            title: insightPageTitle,
            description: insightPageDescription,
            image: insight.image_preview
        },
        twitterTags: {
            card: "summary_large_image"
        },
        authorTag: (_author_name = insight.author_name) !== null && _author_name !== void 0 ? _author_name : undefined
    };
    return ideaPageMetadata;
};
/**
 * @link /mobile-app
 * @returns {PageMetadata} basic metadata
 */ var getMobileAppPageMetadata = function() {
    var mobileAppPageMetadata = {
        pageTitle: "Get the app",
        pageDescription: _strings_pageStrings__WEBPACK_IMPORTED_MODULE_6__/* ["default"].about.pageDescription */ .Z.about.pageDescription,
        canonical: "https://deepstash.com/mobile-app",
        robotsTag: "index",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
    return mobileAppPageMetadata;
};
/**
 * @link /curators
 * @returns {PageMetadata} basic metadata
 */ var getCuratorsPageMetadata = function() {
    var curatorsMetadata = {
        pageTitle: "Curators",
        pageDescription: "You are your thoughts. It’s our goal to help you become more inspired, wiser and productive, through bite-sized ideas.",
        canonical: "https://deepstash.com/curators",
        robotsTag: "index",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
    return curatorsMetadata;
};
/**
 * @link /email_unsubscribe
 * @returns {PageMetadata} basic metadata
 */ var getEmailUnsubscribePageMetadata = function() {
    var metadata = {
        pageTitle: "Email Unsubscribe",
        pageDescription: "",
        canonical: "https://deepstash.com/email_unsubscribe",
        robotsTag: "index"
    };
    return metadata;
};
/**
 * @link /about
 * @returns {PageMetadata} jsonld metadata
 */ var getAboutPageMetadata = function() {
    var aboutPageMetadata = {
        pageTitle: "About",
        pageDescription: _strings_pageStrings__WEBPACK_IMPORTED_MODULE_6__/* ["default"].about.pageDescription */ .Z.about.pageDescription,
        canonical: "https://deepstash.com/about",
        robotsTag: "index",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS,
        structuredDataObjects: [
            (0,react_schemaorg_dist_src_json_ld__WEBPACK_IMPORTED_MODULE_1__.jsonLdScriptProps)({
                "@context": "https://schema.org",
                "@type": "AboutPage",
                description: _strings_pageStrings__WEBPACK_IMPORTED_MODULE_6__/* ["default"].about.pageDescription */ .Z.about.pageDescription,
                image: "https://static.deepstash.com/deepstash-logo.png",
                name: "Deepstash",
                url: "https://deepstash.com",
                version: "".concat("7.4.5")
            }), 
        ]
    };
    return aboutPageMetadata;
};
/**
 * @link /featured
 * @return {PageMetadata} basic metadata
 */ var getFeaturedPageMetadata = function() {
    var featuredMetadata = {
        pageTitle: "Featured Articles",
        pageDescription: "Discover featured stashes, articles and ideas happening right now. Don’t miss out on our team’s picks for today.",
        canonical: "https://deepstash.com/featured",
        robotsTag: "index",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
    return featuredMetadata;
};
/**
 * @link /notifications
 * @return {PageMetadata} metadata
 */ var getNotificationsPageMetadata = function() {
    var metadata = {
        pageTitle: "Notifications",
        pageDescription: "See your notifications",
        canonical: "https://deepstash.com/notifications",
        robotsTag: "index"
    };
    return metadata;
};
/**
 * @link /password_reset
 * @return {PageMetadata} metadata
 */ var getPasswordResetPageMetadata = function() {
    var pageMetadata = {
        pageTitle: "Reset Password",
        pageDescription: "Reset your password",
        canonical: "https://deepstash.com/password_reset",
        robotsTag: "index"
    };
    return pageMetadata;
};
/**
 * @link /press-kit
 * @return {PageMetadata} metadata
 */ var getPressKitPageMetadata = function() {
    var pressKitMetadata = {
        pageTitle: "Press Kit",
        pageDescription: "You are your thoughts. It’s our goal to help you become more inspired, wiser and productive, through bite-sized ideas.",
        canonical: "https://deepstash.com/press-kit",
        robotsTag: "index",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
    return pressKitMetadata;
};
/**
 * @link /privacy-policy
 * @return {PageMetadata} metadata
 */ var getPrivacyPolicyMetadata = function() {
    var pageMetadata = {
        pageTitle: "Privacy Policy",
        pageDescription: "Deepstash takes your data privacy seriously. Our privacy policy entails who we are, how we collect, share and use your personal information.",
        canonical: "https://deepstash.com/privacy-policy",
        robotsTag: "index",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
    return pageMetadata;
};
/**
 * @link /progress
 * @return {PageMetadata} metadata
 */ var getProgressPageMetadata = function() {
    var progressMetadata = {
        pageTitle: "Progress",
        pageDescription: "See your progress",
        canonical: "https://deepstash.com/progress",
        robotsTag: "index"
    };
    return progressMetadata;
};
/**
 * @link /
 * @return {PageMetadata} metadata
 */ var getStashingPageMetadata = function() {
    var stashingPageMetadata = {
        pageTitle: "The art of stashing",
        pageDescription: "Best practices to stashing articles you come across",
        canonical: "https://deepstash.com/stashing",
        robotsTag: "index"
    };
    return stashingPageMetadata;
};
/**
 * @link /terms-of-service
 * @return {PageMetadata} metadata
 */ var getTermsOfServicePageMetadata = function() {
    var tosPageMetadata = {
        pageTitle: "Terms of Service",
        pageDescription: "Please read the following terms of service before you install the Deepstash application or use any of the products or services we provide through our application, software or website.",
        canonical: "https://deepstash.com/terms-of-service",
        robotsTag: "index",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
    return tosPageMetadata;
};
/**
 * @link /trending
 * @return {PageMetadata} metadata
 */ var getTrendingPageMetadata = function() {
    var trendingPageMetadata = {
        pageTitle: "Trending Articles",
        pageDescription: "Discover popular stashes, articles and ideas happening right now. Don’t miss out on today’s hot trends.",
        canonical: "https://deepstash.com/trending",
        robotsTag: "index",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
    return trendingPageMetadata;
};
/**
 * @link /content-review-article/[id]
 * @return {PageMetadata} metadata
 */ var getContentReviewArticlePageMetadata = function(param) {
    var data = param.data;
    var _title;
    var contentReviewMetadata = {
        pageTitle: (_title = data.title) !== null && _title !== void 0 ? _title : "",
        pageDescription: "Review " + data.title,
        canonical: "https://deepstash.com/content-review-article/" + data.id,
        robotsTag: "noindex"
    };
    return contentReviewMetadata;
};
/**
 * @link /content-review-articles/in-review
 * @return {PageMetadata} metadata
 */ var getContentReviewArticlesInReviewPageMetadata = function() {
    var contentReviewMetadata = {
        pageTitle: "In Review",
        pageDescription: "View articles in review",
        canonical: "https://deepstash.com/content-review-articles/in-review",
        robotsTag: "noindex"
    };
    return contentReviewMetadata;
};
/**
 * @link /content-review-articles/all-drafts
 * @return {PageMetadata} metadata
 */ var getContentReviewArticlesAllDraftsPageMetadata = function() {
    var contentReviewMetadata = {
        pageTitle: "Assigned Articles",
        pageDescription: "View assigned articles",
        canonical: "https://deepstash.com/content-review-articles/all-drafts",
        robotsTag: "noindex"
    };
    return contentReviewMetadata;
};
/**
 * @link /delete-account
 * @return {PageMetadata} metadata
 */ var getDeleteAccountPageMetadata = function() {
    var deleteAccountPageMetadata = {
        pageTitle: "Delete Account",
        pageDescription: "Delete your account",
        canonical: "https://deepstash.com/settings/delete-account",
        robotsTag: "noindex"
    };
    return deleteAccountPageMetadata;
};
/**
 * @link /email-subscription
 * @return {PageMetadata} metadata
 */ var getEmailSubscriptionsPageMetadata = function() {
    var emailSubscriptionsPageMetadata = {
        pageTitle: "Email Subscriptions",
        pageDescription: "View your email subscriptions",
        canonical: "https://deepstash.com/settings/email-subscriptions",
        robotsTag: "index"
    };
    return emailSubscriptionsPageMetadata;
};
/**
 * @link /personal-information
 * @return {PageMetadata} metadata
 */ var getPersonalInformationPageMetadata = function() {
    var personalInformationPageMetadata = {
        pageTitle: "Personal Information",
        pageDescription: "View your personal information",
        canonical: "https://deepstash.com/settings/personal-information",
        robotsTag: "index"
    };
    return personalInformationPageMetadata;
};
/**
 * @link /preferences
 * @return {PageMetadata} metadata
 */ var getPreferencesPageMetadata = function() {
    var personalInformationPageMetadata = {
        pageTitle: "Preferences",
        pageDescription: "View your preferences",
        canonical: "https://deepstash.com/settings/preferences",
        robotsTag: "index"
    };
    return personalInformationPageMetadata;
};
/**
 * @link /ref
 * @return {PageMetadata} metadata
 */ var getRefPageMetadata = function() {
    var invitePageMetadata = {
        pageTitle: "Invite",
        pageDescription: "Invitation to join Deepstash",
        canonical: "https://deepstash.com/ref",
        robotsTag: "noindex",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
    return invitePageMetadata;
};
/**
 * @link /settings
 * @return {PageMetadata} metadata
 */ var getSettingsPageMetadata = function() {
    var settingsPageMetadata = {
        pageTitle: "Settings",
        pageDescription: "View your personal settings",
        canonical: "https://deepstash.com/settings",
        robotsTag: "index"
    };
    return settingsPageMetadata;
};
/**
 * TO BE DELETED APPARENTLY?
 * @link /likes
 * @return {PageMetadata} metadata
 */ var getLikesPageMetadata = function(param) {
    var user = param.user;
    var name = user.first_name || user.last_name ? "".concat(user.first_name, " ").concat(user.last_name) : user.username;
    var likedPageMetadata = {
        pageTitle: name,
        pageDescription: "See liked posts.",
        canonical: "https://deepstash.com/".concat(user === null || user === void 0 ? void 0 : user.username, "/liked"),
        robotsTag: "index"
    };
    return likedPageMetadata;
};
/**
 * @link /search
 * @return {PageMetadata} metadata
 */ var getSearchPageMetadata = function(searchParams) {
    var ref;
    var pageTitle = searchParams ? "".concat((ref = pages_search__WEBPACK_IMPORTED_MODULE_0__.MENU_OPTIONS.find(function(option) {
        return option.key === searchParams.searchType;
    })) === null || ref === void 0 ? void 0 : ref.title, " ").concat(searchParams.searchType === "user" ? "named" : "related to", " '").concat(searchParams.searchText, "'") : "Search";
    var searchPageMetadata = {
        pageTitle: pageTitle,
        pageDescription: "Search for ideas, topics, articles, books, podcasts, and more...",
        canonical: "https://deepstash.com/search",
        robotsTag: "noindex",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
    return searchPageMetadata;
};
/**
 * @link /[genericTag]
 * @return {PageMetadata} metadata
 */ var getInfluencerPageMetadata = function(param) {
    var influencer = param.influencer;
    var influencerPageMetadata = {
        pageTitle: "Start your stashing journey with ".concat(influencer.creator_name),
        pageDescription: "".concat(influencer.creator_name, " (@").concat(influencer.user.username, ") invites you to join Deepstash Pro with a discount to our subscription!"),
        robotsTag: "noindex",
        canonical: "https://deepstash.com" + influencer.influencerPath,
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
    return influencerPageMetadata;
};
/**
 * @link /
 * @return {PageMetadata} metadata
 */ var getHomePageMetadata = function() {
    var homePageMetadata = {
        pageTitle: _strings_commonStrings__WEBPACK_IMPORTED_MODULE_5__/* ["default"].homePage.pageTitle */ .Z.homePage.pageTitle,
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS,
        pageDescription: _strings_commonStrings__WEBPACK_IMPORTED_MODULE_5__/* ["default"].homePage.pageDescription */ .Z.homePage.pageDescription,
        canonical: "https://deepstash.com",
        robotsTag: "index",
        structuredDataObjects: [
            (0,react_schemaorg_dist_src_json_ld__WEBPACK_IMPORTED_MODULE_1__.jsonLdScriptProps)({
                "@context": "https://schema.org",
                "@type": "Organization",
                name: "Deepstash",
                url: "https://deepstash.com",
                logo: "https://static.deepstash.com/deepstash.png",
                sameAs: [
                    "https://www.facebook.com/deepstash/",
                    "https://twitter.com/deepstash/",
                    "https://www.instagram.com/deepstash/",
                    "https://www.youtube.com/channel/UCXh3Zca5WIW0C_tQJrDoa1w",
                    "https://www.linkedin.com/company/deepstash/",
                    "https://deepstash.com", 
                ]
            }),
            (0,react_schemaorg_dist_src_json_ld__WEBPACK_IMPORTED_MODULE_1__.jsonLdScriptProps)({
                "@context": "https://schema.org",
                "@type": "WebSite",
                url: "https://deepstash.com",
                potentialAction: {
                    "@type": "SearchAction",
                    target: "https://deepstash.com/search?q={search_term_string}",
                    "query-input": "required name=search_term_string"
                }
            }), 
        ]
    };
    return homePageMetadata;
};
/**
 * @link /producthunt
 * @return {PageMetadata} metadata
 */ var getProductHuntPageMetadata = function() {
    var productHuntPageMetadata = {
        pageTitle: _strings_commonStrings__WEBPACK_IMPORTED_MODULE_5__/* ["default"].homePage.pageTitle */ .Z.homePage.pageTitle,
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS,
        pageDescription: _strings_commonStrings__WEBPACK_IMPORTED_MODULE_5__/* ["default"].homePage.pageDescription */ .Z.homePage.pageDescription,
        canonical: "https://deepstash.com/producthunt",
        robotsTag: "noindex",
        structuredDataObjects: [
            (0,react_schemaorg_dist_src_json_ld__WEBPACK_IMPORTED_MODULE_1__.jsonLdScriptProps)({
                "@context": "https://schema.org",
                "@type": "Organization",
                name: "Deepstash",
                url: "https://deepstash.com",
                logo: "https://static.deepstash.com/deepstash.png",
                sameAs: [
                    "https://www.facebook.com/deepstash/",
                    "https://twitter.com/deepstash/",
                    "https://www.instagram.com/deepstash/",
                    "https://www.youtube.com/channel/UCXh3Zca5WIW0C_tQJrDoa1w",
                    "https://www.linkedin.com/company/deepstash/",
                    "https://deepstash.com", 
                ]
            }), 
        ]
    };
    return productHuntPageMetadata;
};
/**
 * @link /draft/[id]
 * @return {PageMetadata} metadata
 */ var getDraftPageMetadata = function() {
    var addSourceMetadata = {
        pageTitle: "Add Ideas",
        pageDescription: "Add ideas to your draft post.",
        canonical: "",
        robotsTag: "noindex"
    };
    return addSourceMetadata;
};
/**
 * @link /404
 * @return {PageMetadata} metadata
 */ var getErrorPageMetadata = function() {
    var errorPageMetadata = {
        pageTitle: "404 Page not found",
        pageDescription: "The requested page has not been found.",
        canonical: "https://deepstash.com/404",
        robotsTag: "noindex"
    };
    return errorPageMetadata;
};
/**
 * @link /stashes
 * @return {PageMetadata} metadata
 */ var getStashesPageMetadata = function(param) {
    var user = param.user;
    var name = user.first_name || user.last_name ? "".concat(user.first_name, " ").concat(user.last_name) : user.username;
    var stashesPageMetadata = {
        pageTitle: name,
        pageDescription: "See stashed posts.",
        canonical: "https://deepstash.com/u/".concat(user === null || user === void 0 ? void 0 : user.username, "/stashes"),
        robotsTag: "index"
    };
    return stashesPageMetadata;
};
/**
 * @link /all-collections
 * @return {PageMetadata} metadata
 */ var getAllCollectionsPageMetadata = function() {
    var allCollectionsPageMetadata = {
        pageTitle: "All Collections",
        pageDescription: "See your collections.",
        canonical: "https://deepstash.com/all-collections",
        robotsTag: "noindex"
    };
    return allCollectionsPageMetadata;
};
/**
 * @link /collection/[id]/[slug], 301 redirects: /collection/[id], /collection/[id]/[wrong-slug]
 * @return {PageMetadata} jsonld + opengraph metadata
 */ var getCollectionPageMetadata = function(param) {
    var collection = param.collection;
    var ref;
    var collectionDescription = collection.hashtags ? "Read this collection on #" + collection.hashtags[0] + " and more." : "Read this collection of " + collection.ideaCount + " ideas.";
    var canonicalUrl = "https://deepstash.com/collection/".concat(collection.id, "/").concat((0,_global__WEBPACK_IMPORTED_MODULE_4__/* .slugify */ .lV)(collection.name));
    var ref1;
    var collectionPageMetadata = {
        pageTitle: collection.name,
        pageDescription: collectionDescription,
        canonical: canonicalUrl,
        robotsTag: "index",
        openGraphTags: {
            title: collection.name,
            description: collectionDescription,
            type: "collection",
            image: collection.imagePreview
        },
        twitterTags: {
            card: "summary_large_image"
        },
        structuredDataObjects: [
            (0,react_schemaorg_dist_src_json_ld__WEBPACK_IMPORTED_MODULE_1__.jsonLdScriptProps)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                "@context": "https://schema.org",
                "@type": "Collection",
                mainEntityOfPage: {
                    "@type": "WebPage",
                    "@id": "https://deepstash.com/collection/".concat(collection.id)
                }
            }, collection.imageUrl && {
                image: collection.imageUrl
            }), {
                name: collection.name,
                sameAs: canonicalUrl,
                collectionSize: (ref1 = (ref = collection.sources) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0
            })), 
        ]
    };
    return collectionPageMetadata;
};
/**
 * @link /for-teams
 */ var getForTeamsPageMetadata = function() {
    var forTeamsPageMetadata = {
        pageTitle: "For Teams",
        pageDescription: "Your team is at the heart of your organization’s success. Deepstash helps yours get creative, innovative and engaged.",
        canonical: "https://deepstash.com/for-teams",
        robotsTag: "index",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
    return forTeamsPageMetadata;
};
/**
 * @link /get-pro
 */ var getGetProPageMetadata = function() {
    var forTeamsPageMetadata = {
        pageTitle: "Get Pro",
        pageDescription: "Members get access to 200k+ bite-sized ideas from 35 categories that cater to professional or personal goals & skills.",
        canonical: "https://deepstash.com/get-pro",
        robotsTag: "index",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
    return forTeamsPageMetadata;
};
/**
 * @link /explore
 */ var getExplorePageMetadata = function() {
    return {
        pageTitle: "Explore",
        pageDescription: "Explore the world’s best ideas: 200,000+ ideas on pretty much any topic. Created by the smartest people around & well-organized so you can explore at will.",
        canonical: "https://deepstash.com/explore",
        robotsTag: "index",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
};
/**
 * @link /explore/sources/page/{sourceType}
 */ var getExploreSourceTypePageMetadata = function(sourceTypePlural) {
    return {
        pageTitle: "Explore ".concat(sourceTypePlural),
        pageDescription: "Explore the world’s best ideas from ".concat(sourceTypePlural, ". Created by the smartest people around & well-organized so you can explore at will."),
        canonical: "https://deepstash.com/explore/sources/page/".concat(sourceTypePlural),
        robotsTag: "index",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
};
/**
 * @link /explore/sources/{pageType}/{sourceType}
 */ var getExploreSourceTypeSeeAllPageMetadata = function(param) {
    var sourceTypePlural = param.sourceTypePlural, pageTitle = param.pageTitle, pageType = param.pageType;
    return {
        pageTitle: "Explore ".concat(pageTitle),
        pageDescription: "Explore the world’s best ideas from ".concat(sourceTypePlural, ". Created by the smartest people around & well-organized so you can explore at will."),
        canonical: "https://deepstash.com/explore/sources/".concat(pageType, "/").concat(sourceTypePlural),
        robotsTag: "index",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
};
/**
 * @link /explore/daily_picks
 */ var getExploreDailyPicksMetadata = function() {
    return {
        pageTitle: "Explore Daily Picks",
        pageDescription: "Explore the best daily content from Deepstash, hand-picked by our curators.",
        canonical: "https://deepstash.com/explore/daily_picks",
        robotsTag: "index",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
};
/**
 * @link /explore/daily-picks/history/?type={pageType}
 */ var getExploreDailyPicksHistoryMetadata = function(pageTitle, pageType) {
    return {
        pageTitle: "Explore ".concat(pageTitle),
        pageDescription: "Explore all the past daily picks from our curators.",
        canonical: "https://deepstash.com/explore/daily_picks/history/?type=".concat(pageType),
        robotsTag: "index",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
};
/**
 * @link /following
 * @return {PageMetadata} metadata
 */ var getFollowingPageMetadata = function() {
    var addSourceMetadata = {
        pageTitle: "Following",
        pageDescription: "",
        canonical: "/following",
        robotsTag: "noindex",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
    return addSourceMetadata;
};
/**
 * @link /recommended
 * @return {PageMetadata} metadata
 */ var getRecommendedPageMetadata = function() {
    var addSourceMetadata = {
        pageTitle: "Recommended",
        pageDescription: "",
        canonical: "/recommended",
        robotsTag: "noindex",
        openGraphTags: DEFAULT_PUBLIC_PAGE_OG_TAGS
    };
    return addSourceMetadata;
};
/**
 * @link /redeem
 */ var getRedeemPageMetadata = function() {
    var redeemPageMetadata = {
        pageTitle: "Redeem Code",
        pageDescription: "",
        canonical: "/redeem",
        robotsTag: "noindex"
    };
    return redeemPageMetadata;
};
/**
 * @link /story/[id]/[slug], 301 redirects: /story/[id], /story/[id]/[wrong-slug]
 * @returns {PageMetadata} jsonld + opengraph metadata
 */ var getStoryPageMetadata = function(param) {
    var story = param.story;
    var canonicalUrl = "https://deepstash.com/story/".concat(story.id, "/").concat((0,_global__WEBPACK_IMPORTED_MODULE_4__/* .slugify */ .lV)(story.title));
    var _image;
    var storyPageMetadata = {
        pageTitle: story.title,
        pageDescription: story.intro,
        canonical: canonicalUrl,
        robotsTag: "index, max-image-preview:large",
        openGraphTags: {
            title: story.title,
            description: story.intro,
            type: "article",
            image: (_image = story.image) !== null && _image !== void 0 ? _image : undefined
        },
        twitterTags: {
            card: "summary_large_image"
        }
    };
    return storyPageMetadata;
};
/**
 * @link /studio
 */ var getStudioPageMetadata = function() {
    var studioPageMetadata = {
        pageTitle: "Deepstash Studio",
        pageDescription: "Unleash your creativity and spread ideas that make an impact.",
        canonical: "/studio",
        robotsTag: "index"
    };
    return studioPageMetadata;
};


/***/ })

}]);